module.exports = __webpack_public_path__ + "img/vision.815b1676.png";